import colorModel from './colorModel.vue';
export default {
  components: {
    colorModel
  },
  props: {
    configureList: {
      type: Array,
      default() {
        return [];
      }
    },
    styleObj: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      form: {},
      colorShow: false,
      policyStatus: [{
        label: '待生效',
        value: 1
      }, {
        label: '保障中',
        value: 2
      }]
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.form = this.styleObj;
      console.log(this.form, '-------policyDetail--------');
    });
  },
  methods: {
    changeFun() {
      this.$emit('itemChange', this.form);
    },
    imgClick(val, id) {
      this.form.controlsComponentsMark = val;
      this.form.controlsComponentsId = id;
      this.changeFun();
    },
    colorClickFun(val, key) {
      this.colorShow = true;
      this.$nextTick(() => {
        this.$refs.colorRef.init(val, key);
      });
    },
    colorFun(val, key) {
      this.form[key] = val;
      this.changeFun();
      this.colorShow = false;
    },
    //按钮文案去除前后空格
    handleBlurTrim(e) {
      this.form.policyCancelConfig.uncancelableTips = e.target.value.trim();
    }
  }
};